// Mock data for Metaj Construction Sàrl Landing Page

export const companyInfo = {
  name: "Metaj Construction Sàrl",
  tagline: "Votre partenaire en construction métallique, serrurerie & solaire",
  subtagline: "Solutions sur mesure, durables et fiables",
  address: {
    street: "Chemin des Vergers 15",
    postalCode: "1562",
    city: "Corcelles-près-Payerne",
    country: "Suisse"
  },
  phone: [
    { number: "+41 79 732 02 11", name: "Rahim Metaj", role: "Administrateur" },
    { number: "+41 79 176 65 39", name: "Shaban Duli", role: "Responsable Clientèle" }
  ],
  email: "info@metajconstruction.ch"
};

export const services = [
  {
    id: 1,
    title: "Construction métallique",
    description: "Garde-corps (intérieur ou extérieur) en inox, acier thermolaqué (RAL à choix selon client), en verre sécurisé – Escaliers intérieurs et extérieurs en grille caillebotis ou en bois – Pergolas – Abris voiture – Charpente métallique – Façades métalliques ventilées",
    image: "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/xjdlw6z1_WhatsApp%20Image%202026-04-12%20at%2016.54.02%20%281%29.jpeg",
    detailedDescription: "Nous concevons et réalisons des structures métalliques sur mesure, alliant précision, durabilité et finition soignée. De la fabrication en atelier à la pose sur chantier, chaque projet est mené avec rigueur pour répondre aux exigences esthétiques et techniques. Garde-corps, escaliers, pergolas, charpentes et façades — notre savoir-faire couvre l'ensemble des ouvrages métalliques, en inox, acier thermolaqué ou verre sécurisé.",
    gallery: [
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/xjdlw6z1_WhatsApp%20Image%202026-04-12%20at%2016.54.02%20%281%29.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/nqlmzk0p_WhatsApp%20Image%202026-04-12%20at%2016.54.03%20%282%29.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/27hvkj93_WhatsApp%20Image%202026-04-12%20at%2016.54.03%20%283%29.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/fmw2vc5c_WhatsApp%20Image%202026-04-12%20at%2016.54.03%20%2811%29.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/kbiiq49v_WhatsApp%20Image%202026-04-12%20at%2017.33.23%20%281%29.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/8eqoyc6d_WhatsApp%20Image%202026-04-12%20at%2017.33.23%20%282%29.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/10izhtf8_WhatsApp%20Image%202026-04-12%20at%2017.33.23%20%285%29.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/9o3w9fow_WhatsApp%20Image%202026-04-12%20at%2017.33.24.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/0zxx796w_WhatsApp%20Image%202026-04-12%20at%2018.17.41%20%281%29.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/1atait3n_WhatsApp%20Image%202026-04-12%20at%2018.17.42%20%283%29.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/293l605n_WhatsApp%20Image%202026-04-12%20at%2017.33.22%20%282%29.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/zhb4t6uu_WhatsApp%20Image%202026-04-12%20at%2017.33.23%20%284%29.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/krql8d5i_WhatsApp%20Image%202026-04-12%20at%2018.17.42%20%284%29.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/m8qhp2x9_WhatsApp%20Image%202026-04-12%20at%2018.17.49%20%281%29.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/wr617otg_WhatsApp%20Image%202026-04-12%20at%2018.17.50.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/8q2dfw49_WhatsApp%20Image%202026-04-12%20at%2021.25.58%20%284%29.jpeg"
    ]
  },
  {
    id: 3,
    title: "Installation solaire",
    description: "Installation de panneaux photovoltaïques – Installation de panneaux solaires thermiques",
    image: "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/dn3qqwb9_WhatsApp%20Image%202026-04-12%20at%2016.54.03%20%286%29.jpeg",
    detailedDescription: "Nous installons des systèmes photovoltaïques et solaires thermiques adaptés à chaque toiture, pour une production d'énergie propre et durable. Notre équipe prend en charge l'ensemble du projet : étude de rentabilité, pose des rails et des panneaux, raccordement électrique et mise en service. Nous vous accompagnons également dans les démarches administratives pour bénéficier des subventions fédérales et cantonales disponibles.",
    gallery: [
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/dn3qqwb9_WhatsApp%20Image%202026-04-12%20at%2016.54.03%20%286%29.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/gybl1213_WhatsApp%20Image%202026-04-12%20at%2016.54.03%20%288%29.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/xnh18w38_WhatsApp%20Image%202026-04-12%20at%2016.54.03%20%2810%29.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/9h99fa95_WhatsApp%20Image%202026-04-12%20at%2016.54.03%20%2813%29.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/uoice6xd_WhatsApp%20Image%202026-04-12%20at%2016.54.03%20%2814%29.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/i0uivgp2_WhatsApp%20Image%202026-04-12%20at%2016.54.03%20%2815%29.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/k1i6anjt_WhatsApp%20Image%202026-04-12%20at%2017.33.22%20%281%29.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/8derdsfr_WhatsApp%20Image%202026-04-12%20at%2017.33.22.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/tj1sh3ne_WhatsApp%20Image%202026-04-12%20at%2018.17.42%20%282%29.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/2zybgkoi_WhatsApp%20Image%202026-04-12%20at%2018.17.49%20%282%29.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/ghj7dg6a_WhatsApp%20Image%202026-04-12%20at%2018.17.50%20%281%29.jpeg",
      "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/saigf5sa_WhatsApp%20Image%202026-04-12%20at%2018.17.50%20%282%29.jpeg"
    ]
  },
  {
    id: 2,
    title: "Serrurerie générale",
    description: "Portes coupe-feu – Portes standards – Fenêtres – Baies vitrées",
    image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&h=500&fit=crop",
    detailedDescription: "",
    gallery: []
  },
  {
    id: 4,
    title: "Enseignes lumineuses & adhésifs",
    description: "Enseignes lumineuses – Adhésifs publicitaires – Solutions de visibilité et marquage pour entreprises",
    image: "https://customer-assets.emergentagent.com/job_bb7efc84-760e-46b7-8ef3-ea31b314fc05/artifacts/k9b1nr6o_WhatsApp%20Image%202026-04-12%20at%2017.33.22%20%283%29.jpeg",
    detailedDescription: "",
    gallery: []
  }
];

export const projects = [
  {
    id: 1,
    title: "Garde-corps extérieur",
    beforeImage: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=600&h=400&fit=crop",
    afterImage: "https://images.unsplash.com/photo-1509024368907-57294758cfc5?w=600&h=400&fit=crop"
  },
  {
    id: 2,
    title: "Escalier métallique",
    beforeImage: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=600&h=400&fit=crop",
    afterImage: "https://images.unsplash.com/uploads/14123892966835548e7bd/14369636?w=600&h=400&fit=crop"
  },
  {
    id: 3,
    title: "Installation solaire",
    beforeImage: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=400&fit=crop",
    afterImage: "https://images.unsplash.com/photo-1668097613572-40b7c11c8727?w=600&h=400&fit=crop"
  }
];

export const subsidiesInfo = {
  title: "Installations solaires & subventions",
  description: "La Confédération et les cantons proposent des aides financières pour les installations photovoltaïques. Nous vous accompagnons dans les démarches administratives et l'obtention des subventions disponibles.",
  points: [
    "Subventions fédérales Pronovo",
    "Aides cantonales disponibles",
    "Accompagnement administratif complet",
    "Retour sur investissement optimisé"
  ]
};

export const aboutInfo = {
  title: "Qui sommes-nous",
  description: "Metaj Construction Sàrl est une entreprise spécialisée dans la construction métallique, la serrurerie et les installations solaires. Basée en Suisse romande, nous mettons notre savoir-faire et notre expérience au service de vos projets, avec un engagement constant pour la qualité et la fiabilité."
};

export const recruitmentInfo = {
  title: "Nous recrutons",
  description: "Vous êtes un professionnel qualifié en construction métallique, serrurerie ou installations solaires ? Nous recherchons des collaborateurs motivés pour rejoindre notre équipe."
};

export const heroImage = "https://images.unsplash.com/photo-1509024368907-57294758cfc5?w=1920&h=1080&fit=crop";

export const companyLogo = "https://customer-assets.emergentagent.com/job_build-metal-solar/artifacts/t68zc2op_Logo%20soci%C3%A9t%C3%A9%20Metaj%20Construction%20S%C3%A0rl.png";

export const socialLinks = [
  { name: "LinkedIn", url: "#", icon: "linkedin" },
  { name: "Instagram", url: "#", icon: "instagram" }
];
